import { dictionary } from "@dcc/lookup/dictionary/dictionary";

export enum ActivityCategory {
  ActiveDays = "Active Days",
  EasyTips = "Easy Tips",
  Health = "Health"
}

export type ActivityCategoryIndexer<T> = {
  [id in ActivityCategory]: T;
};

export type activityCategoryStrings = keyof typeof ActivityCategory;

export const getActivityCategoryMap = () => [
  dictionary.DCC_PersonalPlan_ActiveDays,
  dictionary.DCC_PersonalPlan_EasyTips,
  dictionary.DCC_PersonalPlan_Health
];

export const getIndexInCategoryMap = (category: ActivityCategory) => {
  return getActivityCategoryMap().indexOf(category);
};
